import { withRouter } from 'react-router'

class RouteTracer extends React.Component

  componentDidMount: ->
    { match: { path, url, params } } = @props
    try
      user = Weaver.getInstance().currentUser()

    if process.env.NODE_ENV is 'production'
      window.analytics.page("internal-#{path}", {
        url
        user
        space: params.spaceId
      })

  render: ->
    <div />

export default withRouter(RouteTracer)


